import Client1 from "../assets/images/clients/our-client-1.webp"; // Al Masraf
import Client2 from "../assets/images/clients/our-client-2.webp"; // Bahrain Specialist Hospital
import Client3 from "../assets/images/clients/our-client-3.webp"; // MPH
import Client5 from "../assets/images/clients/our-client-5.webp"; // DULSCO
import Client19 from "../assets/images/clients/our-client-19.webp"; // Vertex

export const testimonials = [
    {
        id: 1,
        name: "Pradeep Kairan",
        role: "Co-Founder, Vertex",
        company: "Vertex Aluminium and Facades",
        industry: "Construction",
        logo: Client19,
        quote:
            "The coordination throughout was exemplary. They arranged testing facilities exactly as we requested, handling all logistics seamlessly.",
    },
    {
        id: 2,
        name: "Ahmed Al-Mansour",
        role: "HR Director, Al Masraf",
        company: "Al Masraf",
        industry: "Banking",
        logo: Client1,
        quote:
            "Partnering with Angel Gulf Jobs has been a strategic asset for our recruitment needs. Their understanding of the banking sector's requirements and their ability to source high-caliber candidates from India is commendable. A truly professional and reliable consultancy.",
    },
    {
        id: 3,
        name: "Sarah Jenkins",
        role: "Talent Acquisition Head, MPH",
        company: "MPH",
        industry: "Construction",
        logo: Client3,
        quote:
            "We have worked with numerous agencies, but Angel Gulf Jobs stands out for their transparency and efficiency. They delivered a specialized team of engineers for our project in record time. Their screening process is rigorous, saving us valuable time.",
    },
    {
        id: 4,
        name: "Dr. Youssef Hassan",
        role: "Medical Director, Bahrain Specialist Hospital",
        company: "Bahrain Specialist Hospital",
        industry: "Healthcare",
        logo: Client2,
        quote:
            "In the healthcare sector, quality and credentials are non-negotiable. Angel Gulf Jobs provided us with highly qualified medical professionals who have seamlessly integrated into our hospital. Their attention to compliance and documentation is excellent.",
    },
    {
        id: 5,
        name: "Rajesh Kumar",
        role: "Project Manager, DULSCO",
        company: "DULSCO",
        industry: "Logistics",
        logo: Client5,
        quote:
            "For our large-scale manpower requirements, we needed a partner who could deliver volume without compromising on quality. Angel Gulf Jobs exceeded our expectations. Their support in visa processing and deployment logistics made the entire process hassle-free.",
    },
    // Dummy Data for Pagination Testing
    {
        id: 6,
        name: "John Doe",
        role: "Operations Manager, BuildCorp",
        company: "BuildCorp",
        industry: "Construction",
        logo: Client3, // Reusing logo for demo
        quote: "Exceptional service and timely delivery of skilled labor. Highly recommended for construction projects.",
    },
    {
        id: 7,
        name: "Fatima Al-Sayed",
        role: "HR Manager, CarePlus Hospital",
        company: "CarePlus Hospital",
        industry: "Healthcare",
        logo: Client2, // Reusing logo for demo
        quote: "Reliable partner for sourcing nursing staff. The candidates were well-vetted and professional.",
    },
    {
        id: 8,
        name: "Michael Chen",
        role: "CTO, FinTech Solutions",
        company: "FinTech Solutions",
        industry: "Banking",
        logo: Client1, // Reusing logo for demo
        quote: "Found excellent IT talent through Angel Gulf Jobs. They understand the technical requirements well.",
    },
    {
        id: 9,
        name: "David Smith",
        role: "Logistics Head, FastMove",
        company: "FastMove",
        industry: "Logistics",
        logo: Client5, // Reusing logo for demo
        quote: "Great support for our warehouse staffing needs. Quick turnaround time.",
    },
    {
        id: 10,
        name: "Elena Rodriguez",
        role: "Project Lead, MegaStruct",
        company: "MegaStruct",
        industry: "Construction",
        logo: Client3, // Reusing logo for demo
        quote: "Professional team that delivers exactly what they promise. Very happy with the collaboration.",
    },
    {
        id: 11,
        name: "Dr. Amir Khan",
        role: "Chief Surgeon, City Med",
        company: "City Med",
        industry: "Healthcare",
        logo: Client2, // Reusing logo for demo
        quote: "Top-notch recruitment service for medical specialists. Will definitely work with them again.",
    },
];
